const space = "\u0020\u200c"; // Spaces
const underscore = "\u005F"; // _
const dash = "\u002D"; // -

const symbol1 = "\u060C"; // ،
const symbol2 = "\u061B"; // ؛
const symbol3 = "\u061F"; // ؟
const symbol4 = "\u066A\u0025"; // %
const symbol5 = "\u066B\u002C"; // ,
const symbol6 = "\u066C"; // !
const symbol7 = "\u0022"; // "
const symbol8 = "\u0027"; // '
const symbol9 = "\u0028"; // (
const symbol10 = "\u0029"; // )
const symbol11 = "\u002E"; // .
const symbol12 = "\u003A"; // :
const symbol13 = "\u003F"; // ?

// const symbols = `${dash}${underscore}${symbol1}${symbol2}${symbol3}${symbol4}${symbol5}${symbol6}${symbol7}${symbol8}${symbol9}${symbol10}${symbol11}${symbol12}${symbol13}`;

const motions = "\u064B-\u0651"; // ً  ٌ  ٍ  َ	  ُ	  ِ	  ّ
const motionsList = [/ َ/g, / ُ/g, / ِ/g, / ّ/g, /ً/g, / ٌ/g, / ٍ/g];

const persianNumbers = "\u06F0-\u06F9"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const arabicNumbers = "\u0660-\u0669"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const persianNumbersList = [
	/۰/g,
	/۱/g,
	/۲/g,
	/۳/g,
	/۴/g,
	/۵/g,
	/۶/g,
	/۷/g,
	/۸/g,
	/۹/g,
];
const arabicNumbersList = [
	/٠/g,
	/١/g,
	/٢/g,
	/٣/g,
	/٤/g,
	/٥/g,
	/٦/g,
	/٧/g,
	/٨/g,
	/٩/g,
];

const persian1 = "\u0621-\u0628"; // ء آ أ	ؤ	إ	ئ	ا ب
const persian2 = "\u062A-\u063A"; // ت  ث  ج  ح  خ  د  ذ  ر  ز  س  ش  ص  ض  ط  ظ  ع  غ
const persian3 = "\u0641-\u0642"; // ف  ق
const persian4 = "\u0644-\u0648"; // ل م ن ه و
const persian5 = "\u06CC\u064A\u0649"; // ی
const persian6 = "\u0655"; //  ٕ
const persian7 = "\u067E"; // پ
const persian8 = "\u0686"; // چ
const persian9 = "\u0698"; // ژ
const persian10 = "\u06A9\u0643"; // ک
const persian11 = "\u06AF"; // گ
const persian12 = "\u06BE\u06D5\u0629"; // ھ

const persianLetter = `${persian1}${persian2}${persian3}${persian4}${persian5}${persian6}${persian7}${persian8}${persian9}${persian10}${persian11}${persian12}`;

export const isPostalCode = (str) => {
	const reg = new RegExp(`^([0-9]{10})$`);
	return reg.test(str);
};

export const isEnWithoutNumber = (str) => {
	const reg = new RegExp("/^[A-Za-z]{1,}$/");
	return reg.test(str);
};

export const isPersianWithNumber = (str) => {
	const reg = new RegExp(
		`^[${space}${persianNumbers}${arabicNumbers}0-9${persianLetter}${motions}]*$`
	);
	return reg.test(str);
};

export const isAddress = (str) => {
	const s = `\u060C\u061B\u061F\u066A\u0025\u066B\u002C\u066C\u0022\u0027\u0028 \u0029 \u002E \u003A \u003F${dash}\u2022\u060C`;
	const reg = new RegExp(`(.[${s}].)|([${s}].)|(.[${s}])|([${s}])`);
	return reg.test(str);
};

export const isPersianWithoutNumber = (str) => {
	const reg = new RegExp(`^[${space}${persianLetter}${motions}]*$`);
	return reg.test(str);
};

export const isPersianWihsymbol = (str) => {
	const reg = new RegExp(
		`^([${persianLetter}${space}${persianNumbers}${arabicNumbers}${motions}${dash}\u2022\u060C]){2,}$`
	);
	return reg.test(str);
};

export const isFullName = (str) => {
	const reg = new RegExp(
		`^([${persianLetter}]){2,}([${space}]){1}(([${persianLetter}]){1,}(([${space}]){1}([${persianLetter}]){1,}){1,}|([${persianLetter}]){2,})$`
	);
	return reg.test(str);
};

export const isNumber = (str) => {
	const number = new RegExp(`^[0-9${persianNumbers}${arabicNumbers}]*$`);
	return number.test(str);
};

export const isPhoneNumber = (str) => {
	const phoneNumber = new RegExp(`^09[0-9]{9}$`);
	return phoneNumber.test(str);
};

export const correctCharacters = (str) => {
	str = str.replace("‌", " ");
	for (let i = 0; i < 10; i += 1) {
		str = str.replace(motionsList[i], "");
	}
	for (let i = 0; i < 10; i += 1) {
		str = str
			.replace(persianNumbersList[i], i)
			.replace(arabicNumbersList[i], i);
	}
	return str;
};

let err;
let err2;
export const nationalId = (val) => {
	const nationalId = new RegExp("^[0-9]{10}$");
	if (nationalId.test(val)) {
		let code = Math.floor(val / 10);
		let mode = 0;
		for (let i = 2; i <= 10; i += 1) {
			mode += (code % 10) * i;
			code = Math.floor(code / 10);
		}
		const result = mode % 11;
		if (result <= 2) {
			if (!(result === parseInt(val, 10) % 10)) {
				err = true;
			}
		} else if (result > 2) {
			if (!(11 - result === parseInt(val, 10) % 10)) {
				err = true;
			}
		}
	}
};

export const meli = (val) => {
	const meliId = new RegExp("^[0-9]{11}$");
	if (meliId.test(val)) {
		const code = meliId % 10;
		const sabet = Math.floor((meliId % 100) / 10) + 2;
		const times = [29, 27, 23, 19, 17, 29, 27, 23, 19, 17];
		let sum = 0;
		let digit = Math.floor(meliId / 10);

		for (let i = 9; i > -1; i -= 1) {
			sum += ((digit % 10) + sabet) * times[i];
			digit = Math.floor(digit / 10);
		}
		const r = sum % 11 === 10 ? 0 : sum % 11;
		if (code !== r) {
			err2 = true;
		}
	}
};

export const meliIdValidation = (code) => {
	if (code.search("/") !== -1) {
		code = code.split("/")[0];
	}
	const L = code.length;
	if (L < 11 || parseInt(code, 10) === 0) {
		return false;
	}
	if (parseInt(code.substr(3, 6), 10) === 0) {
		return false;
	}
	const c = parseInt(code.substr(10, 1), 10);
	const d = parseInt(code.substr(9, 1), 10) + 2;
	const z = [29, 27, 23, 19, 17];
	let s = 0;
	for (let i = 0; i < 10; i += 1) {
		s += (d + parseInt(code.substr(i, 1), 10)) * z[i % 5];
	}
	s %= 11;
	if (s === 10) {
		s = 0;
	}
	return c === s;
};

export const nationalIdValidation = (code) => {
	const L = code.length;
	if (L < 8 || parseInt(code, 10) === 0) {
		return false;
	}
	code = `0000${code}`.substr(L + 4 - 10);
	if (parseInt(code.substr(3, 6), 10) === 0) {
		return false;
	}
	const c = parseInt(code.substr(9, 1), 10);
	let s = 0;
	for (let i = 0; i < 9; i += 1) {
		s += parseInt(code.substr(i, 1), 10) * (10 - i);
	}
	s %= 11;
	return (s < 2 && c === s) || (s >= 2 && c === 11 - s);
};

// console.log(isFullName('سید حمید رضا طالب زاده حسین آبادی اصل'));